import * as types from "./constant"

const initialState = {
  loading: false,
  LOB: [],
  SUBLOB: [],
  INSCOMPANY: [],
  errorMsg: [],
  updated: false,
  Iscreated: false,
  deleted: false,
}

const SuperAdminLOB = (state = initialState, action) => {
  switch (action.type) {
    // View LOB
    case types.GET_SU_LOB_START:
    case types.GET_SU_SUB_LOB_START:
    case types.GET_INSURANCE_COMPANY_START:
      return {
        ...state,
        loading: true,
      }
    case types.GET_SU_LOB_SUCCESS:
      return {
        ...state,
        loading: false,
        LOB: action.payload,
      }
    case types.GET_SU_SUB_LOB_SUCCESS:
      return {
        ...state,
        loading: false,
        SUBLOB: action.payload,
      }
    case types.GET_INSURANCE_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        INSCOMPANY: action.payload,
      }
    case types.GET_INSURANCE_COMPANY_FAILED:
      return {
        ...state,
        loading: false,
        errorMsg: action.payload.message,
      }
    case types.GET_SU_SUB_LOB_FAILED:
      return {
        ...state,
        loading: false,
        SUBLOB: action.payload.message,
      }
    case types.GET_SU_LOB_FAILED:
      return {
        ...state,
        loading: false,
        LOB: [],
      }

    // CREATE LOB
    case types.CREATE_SU_LOB_START:
    case types.CREATE_SU_SUB_LOB_START:
    case types.CREATE_INSURANCE_COMPANY_START:
      return {
        ...state,
        loading: true,
      }
    case types.CREATE_SU_SUB_LOB_SUCCESS:
    case types.CREATE_SU_LOB_SUCCESS:
    case types.CREATE_INSURANCE_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        Iscreated: true,
      }
    case types.CREATE_SU_LOB_RESET:
    case types.CREATE_SU_SUB_LOB_RESET:
    case types.CREATE_INSURANCE_COMPANY_RESET:
      return {
        ...state,
        loading: false,
        Iscreated: false,
      }

    // LOB UPDATE
    case types.UPDATE_SU_SUB_LOB_START:
    case types.UPDATE_SU_LOB_START:
    case types.UPDATE_INSURANCE_COMPANY_START:
      return {
        ...state,
        loading: true,
      }
    case types.UPDATE_SU_SUB_LOB_SUCCESS:
    case types.UPDATE_SU_LOB_SUCCESS:
    case types.UPDATE_INSURANCE_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        updated: true,
      }
    case types.UPDATE_SU_SUB_LOB_FAILED:
    case types.UPDATE_SU_LOB_FAILED:
    case types.UPDATE_INSURANCE_COMPANY_FAILED:
      return {
        ...state,
        loading: false,
        updated: false,
      }

    case types.UPDATE_SU_LOB_RESET:
    case types.UPDATE_SU_SUB_LOB_RESET:
    case types.UPDATE_INSURANCE_COMPANY_RESET:
      return {
        ...state,
        loading: false,
        updated: false,
      }

    // LOB DELETE
    case types.DEL_SU_LOB_START:
    case types.DEL_SU_SUB_LOB_START:
      return {
        ...state,
        loading: true,
      }
    case types.DEL_SU_SUB_LOB_SUCCESS:

    case types.DEL_SU_LOB_SUCCESS:
      return {
        ...state,
        loading: false,
        deleted: true,
      }
    case types.DEL_SU_LOB_FAILED:
    case types.DEL_SU_SUB_LOB_FAILED:
      return {
        ...state,
        loading: false,
        deleted: false,
      }
    case types.DEL_SU_LOB_RESET:
    case types.DEL_SU_SUB_LOB_RESET:
      return {
        ...state,
        loading: false,
        deleted: false,
      }

    default:
      return state
  }
}

export default SuperAdminLOB
